import { render, staticRenderFns } from "./FormApproval.vue?vue&type=template&id=49120a48&"
import script from "./FormApproval.vue?vue&type=script&lang=js&"
export * from "./FormApproval.vue?vue&type=script&lang=js&"
import style0 from "./FormApproval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports